export default "__VITE_ASSET__aefc5f51__"